import { BACKEND_PRIVATE } from './base'

export async function getEscrowBalance() {
  return BACKEND_PRIVATE.get('/me/escrow/balance')
}
